import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Toast, ToastBody, ToastHeader, Container } from 'reactstrap';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import { showDialogLead, saveLead, getLeadModels } from "views/pages/ManageLeads";

const Toaster = React.forwardRef((props, ref) => {
    const [toasts, setToasts] = useState([]);

    const i18nManager = useTranslation();
    const modalGenManager = React.useRef();

    const navigate = useNavigate();

    const addToast = (type, tag, dataToast, args) => {
        if (dataToast?.toGroup === "*") return;

        const id = Date.now();

        const newToast = {
            id,
            header: `Notification ${toasts.length + 1}`,
            message: 'This is a stacked toast message',
        };

        if (dataToast) {
            //TODO : args.autoClose ??
            switch (tag) {
                case "BroadcastMessage":
                    if (dataToast.message.startsWith("{")) {
                        dataToast.message = JSON.parse(dataToast.message);
                        newToast.className = `toast-${dataToast.message.event}`;
                        switch (dataToast.message.event) {
                            case "ringing":
                                newToast.onClick = () => {
                                    removeToast(dataToast.id);

                                    Swal.fire({
                                        title: i18nManager.t("gal_loading"),
                                        didOpen: () => { Swal.showLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    });

                                    var phoneTransform = dataToast.message.appelant.replace("+33", "0");
                                    var args = { phoneNumber: phoneTransform };
                                    commonFunc.getMethod("../api/lead/CheckExistingLeads", args).then((response) => {
                                        if (response.data) {
                                            if (response.data.isSuccess) {
                                                Swal.fire({
                                                    icon: "error",
                                                    title: "Attention",
                                                    html: "Prospect déjà existant"
                                                });
                                                //<Navigate to="/" />
                                                //navigate("../ManageLeads?pageModels=DIALOGLEAD&leadId=" + response.data.result/*, { replace: true, state: { login: loginObj } }*/);
                                            }
                                            else {
                                                getLeadModels("LEAD").then(modelsObj => {
                                                    if (modelsObj?.models) {
                                                        Swal.close();

                                                        var saveCb = () => {
                                                            //alert("save ok");
                                                        };
                                                        showDialogLead(i18nManager.t("lead.add") + " " + dataToast.message.appelant, "DLG_LEAD", { tel: phoneTransform, client: { tel: phoneTransform, contact: { tel: phoneTransform } } }, modelsObj.models, saveLead, saveCb, modalGenManager, props, i18nManager);
                                                    }
                                                    else {
                                                        Swal.fire({
                                                            icon: "error",
                                                            title: i18nManager.t("gal_fail"),
                                                            html: i18nManager.t("gal_failLoadModels") + " :<br>" + modelsObj.response?.errorMessage
                                                        });
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            Swal.fire({
                                                icon: "error",
                                                title: i18nManager.t("gal_error"),
                                                html: i18nManager.t("lead.failLoadLeads")
                                            });
                                        }
                                    });
                                };
                                newToast.header = "Appel Prospect - " + dataToast.toGroup;
                                newToast.message =   `Nouvel appel entrant : ` + dataToast.message.appelant + "\n \nCliquez pour démarrer un nouveau Prospect";
                                break;
                            default:
                                break;
                        }
                    }
                    else {
                        newToast.message = `${dataToast.from}: ${dataToast.message}`;
                    }
                    break;
                case "DirectMessage":
                    newToast.message = `Message de ${dataToast.from}: ${dataToast.message}`;
                    break;


                //info case
                case "Reconnecting"://error / message
                    newToast.message = dataToast.message;
                    break;

                //warning case
                case "ForceDisconnect":
                    newToast.message = `Vous allez être déconnecté: ${dataToast.reason}`;
                    break;

                //success case
                case "ConnectionEstablished":
                    //newToast.message = `Connecté en tant que ${dataToast.extension || dataToast.userName}`;
                    //newToast.message = `Abonné au groupe ${dataToast.extension}`;
                    newToast.message = `A l'écoute des notifications de ${dataToast.extension}`;
                    //return;
                    break;
                case "Reconnected":
                    newToast.message = dataToast;
                    break;

                //error case
                case "Close"://error / message
                case "Exception"://error / message
                    newToast.message = dataToast.message;
                    break;

                default:
                    break;
            }
        }

        setToasts(prev => [newToast, ...prev]);
        // Auto-dismiss after 5 seconds
        setTimeout(() => removeToast(id), 15000);
    };

    const removeToast = id => {
        setToasts(prev => prev.filter(t => t.id !== id));
    };


    React.useImperativeHandle(ref, () => ({
        addToast: addToast,
        removeToast: removeToast,
    }));


    return (
        <Container className="position-relative p-0" style={{ zIndex: 1050 }}>
            <Button color="primary" onClick={addToast} className="m-3 mb-4 d-none">
                Show Toast
            </Button>
            <div
                aria-live="polite"
                aria-atomic="true"
                style={{ position: 'fixed', top: '1rem', right: '1rem', width: '300px' }}
            >
                {toasts.map(toast => (
                    <Toast key={toast.id} className={toast.className}>
                        <ToastHeader toggle={() => removeToast(toast.id)}>
                            {toast.header}
                        </ToastHeader>
                        <ToastBody onClick={toast.onClick}>{toast.message}</ToastBody>
                    </Toast>
                ))}
            </div>
        </Container>
    );
});

export default Toaster;